/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';

import xhr from '../../utils/xhr';
import utils from '../../utils/utils';
import { showNotification } from '../../redux/notification';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import backgroundImage from '../../assets/images/login-background.svg';
import logoIcon from '../../assets/images/portal-logo.svg';

import './Login.scss';

const ForgotPassword = (props) => {
	const dispatch = useDispatch();

	const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
	const [email, setEmail] = useState('');
	const [emailError, setEmailError] = useState('');
	const [requestSent, setRequestSent] = useState(false);

	const reset = async () => {
		if (!email) {
			setEmailError('This field is required');
			return;
		}
		if (!email || !utils.emailRegex.test(email.trim())) {
			setEmailError('Enter a valid email address');
			return;
		}

		setShowLoadingSpinner(true);
		try {
			await xhr.request('POST', `/user/forgot-password`, { email: email.trim() });
			setRequestSent(true);
		} catch (error) {
			const message =
				error.response.data &&
				error.response.data.errors &&
				error.response.data.errors[0] &&
				error.response.data.errors[0].message;
			dispatch(showNotification('error', message || 'Error. Please try again'));
		} finally {
			setShowLoadingSpinner(false);
		}
	};

	return (
		<div className="login-screen">
			<img src={backgroundImage} className="login-background d-none d-md-block" alt="" />
			<div className="login-form-container flex-one">
				<div className="login-form">
					{/* TODO fix eslint - transform to button */}
					{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
					<img src={logoIcon} alt="" className="logo" onClick={() => props.history.replace('/')} />
					{!requestSent ? (
						<div>
							<h1 className="header">Forgot password?</h1>
							<div className="text-forgot-password">
								Please re-enter your email for this account to receive password reset instructions.
							</div>
							<div className="input-step">
								<label htmlFor="email" className="input-step__label">
									Email
								</label>
								<input
									id="email"
									type="email"
									maxLength={128}
									className={`input-step__input ${emailError ? 'is-error' : ''}`}
									placeholder="email@address.com"
									value={email}
									onKeyUp={(e) => e.key === 'Enter' && reset()}
									onChange={(e) => {
										setEmail(e.target.value);
										if (emailError) {
											setEmailError('');
										}
									}}
								/>
								{emailError && <div className="error-message">{emailError}</div>}
							</div>
						</div>
					) : (
						<div>
							<div className="header">Check your email</div>
							<div className="text-forgot-password">
								If the email address you entered is associated with a verified account, you&apos;ll receive a password
								reset link soon.
							</div>
							<div className="text-forgot-password">
								Instructions were sent to: <span>{email}</span>
							</div>
						</div>
					)}

					<div className="button-container">
						<Button size="lg" block onClick={reset} className="continue-button">
							{requestSent ? 'Re-send email' : 'Reset password'}
						</Button>
						<Button
							variant="outline-primary"
							size="lg"
							className="go-back-button"
							onClick={() => {
								if (requestSent) {
									setRequestSent(false);
								} else {
									props.history.replace('/');
								}
							}}
						>
							Go back
						</Button>
					</div>
				</div>
			</div>

			{showLoadingSpinner && <LoadingSpinner />}
		</div>
	);
};

export default withRouter(ForgotPassword);
